export default class RuleUsage {
  businessUnitId: string;

  businessUnitName: string;

  contractId: string;

  contractNumber: string;

  contractExternalId: number;

  contractItemId: string;

  itemNumber: number;

  itemName: string;

  constructor(obj: any = {}) {
    this.businessUnitId = obj.businessUnitId || '';
    this.businessUnitName = obj.businessUnitName || '';
    this.contractId = obj.contractId || '';
    this.contractNumber = obj.contractNumber || '';
    this.contractExternalId = obj.contractExternalId || 0;
    this.contractItemId = obj.contractItemId || '';
    this.itemNumber = obj.itemNumber || 0;
    this.itemName = obj.itemName || '';
  }

  public static of(obj: any = {}): RuleUsage {
    return new RuleUsage(obj);
  }

  public static ofList(obj: any[] = []): RuleUsage[] {
    return obj.map(this.of);
  }
}
